import React from 'react';
import PropTypes from 'prop-types';
import { EventEmitter } from 'events';

const WalkInListButton = ({ onClick }) => {
  const handleClick = () => {
    EventEmitter.prototype.emit('open-walk-in-list-modal');
    if (onClick) {
      onClick();
    }
  };

  return (
    <button type="button" className="c-btn c-btn--medium c-btn--ghost u-ml-" onClick={handleClick}>
      Walk-in List
    </button>
  );
};

WalkInListButton.propTypes = {
  onClick: PropTypes.func,
};

export default WalkInListButton;
